(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aleta-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initAletaPdp(root){
    if(root.dataset.aletaInit === '1') return; /* guard double-init on first load */
    root.dataset.aletaInit = '1';

    /* ---------- gallery swap (src + alt + active state; clear srcset) ---------- */
    var mainImg = root.querySelector('.aleta-gallery__img');
    var galleryBadge = root.querySelector('[data-gallery-badge]');
    var thumbButtons = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    function selectThumb(btn){
      if(mainImg){
        mainImg.src = btn.getAttribute('data-full');
        mainImg.removeAttribute('srcset'); /* stop the responsive set overriding the swap */
        var alt = btn.getAttribute('data-alt'); if(alt){ mainImg.alt = alt; }
      }
      root.querySelectorAll('[data-thumb]').forEach(function(b){ b.classList.remove('is-active'); b.setAttribute('aria-pressed','false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-pressed','true');
      /* first image shows the primary badge; the rest show the "other" badge (falls back to primary) */
      if(galleryBadge){
        var idx = thumbButtons.indexOf(btn);
        var first = galleryBadge.getAttribute('data-badge-first');
        var other = galleryBadge.getAttribute('data-badge-other');
        var txt = (idx <= 0) ? '' : (other || first);
        galleryBadge.textContent = txt || '';
        galleryBadge.style.display = txt ? '' : 'none';
      }
    }
    root.querySelectorAll('[data-thumb]').forEach(function(btn){
      btn.addEventListener('click', function(){ selectThumb(btn); });
    });

    /* ---------- pricing ----------
       One-time price in data-price-money; per-plan allocation prices in
       data-sub-prices ("planId=$xx|planId=$xx"), all money-formatted server-side. */
    var addBtn = root.querySelector('.aleta-add');
    var addLbl = root.querySelector('.aleta-add__label');
    var addPrice = root.querySelector('[data-add-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var stickyBtn = root.querySelector('[data-sticky-add]');
    var subMode = 'once';
    var freqWrap = root.querySelector('[data-freq]');
    var freqSelect = root.querySelector('[data-freq-select]');

    function subPriceMap(el){
      var map = {};
      (el.getAttribute('data-sub-prices') || '').split('|').forEach(function(pair){
        var i = pair.indexOf('=');
        if(i > 0) map[pair.slice(0, i)] = pair.slice(i + 1);
      });
      return map;
    }

    function refreshPrice(){
      var active = root.querySelector('.aleta-size.is-active');
      if(!active) return;
      var show = active.getAttribute('data-price-money');
      if(subMode === 'subscribe' && freqSelect){
        var map = subPriceMap(active);
        if(!map[freqSelect.value]){ var ids = Object.keys(map); if(ids.length) freqSelect.value = ids[0]; }
        if(map[freqSelect.value]) show = map[freqSelect.value];
      }
      if(show && addPrice) addPrice.textContent = show;
      if(show && stickyPrice) stickyPrice.textContent = show;
    }

    /* ---------- size / variant selection (syncs CTA + sticky availability) ---------- */
    function selectSize(label){
      var avail = label.getAttribute('data-available') !== 'false';
      if(!avail) return; /* disabled radios can't be chosen anyway */
      root.querySelectorAll('[data-size]').forEach(function(l){ l.classList.remove('is-active'); });
      label.classList.add('is-active');
      var input = label.querySelector('input[name="id"]');
      if(input) input.checked = true;
      if(addBtn){ addBtn.disabled = false; }
      if(addLbl){ addLbl.textContent = 'Add to bag'; }
      if(stickyBtn){ stickyBtn.disabled = false; stickyBtn.textContent = 'Add to bag'; }
      refreshPrice();
    }
    root.querySelectorAll('[data-size]').forEach(function(label){
      label.addEventListener('click', function(){ selectSize(label); });
      var radio = label.querySelector('input[type="radio"]');
      if(radio) radio.addEventListener('change', function(){ if(radio.checked) selectSize(label); }); /* keyboard */
    });

    /* ---------- subscribe toggle + frequency ----------
       The frequency <select> is name="selling_plan": disabled on one-time
       (nothing submitted), enabled on subscribe (posts the plan id). */
    root.querySelectorAll('[data-purchase] .aleta-purchase__opt').forEach(function(opt){
      opt.addEventListener('click', function(){
        root.querySelectorAll('[data-purchase] .aleta-purchase__opt').forEach(function(o){ o.classList.remove('is-active'); o.setAttribute('aria-pressed','false'); });
        opt.classList.add('is-active'); opt.setAttribute('aria-pressed','true');
        subMode = opt.getAttribute('data-mode');
        var isSub = subMode === 'subscribe';
        if(freqWrap) freqWrap.hidden = !isSub;
        if(freqSelect) freqSelect.disabled = !isSub;
        refreshPrice();
      });
    });
    if(freqSelect) freqSelect.addEventListener('change', refreshPrice);

    /* ---------- add to cart (AJAX + in-page confirmation) ----------
       Replaces the native redirect-to-/cart with an ajax add so the customer
       gets immediate feedback: the button presses in, flips to "Added to bag ✓",
       and the header cart count bumps. Falls back to a native submit on error
       so add-to-cart always works even if JS/network fails. */
    var cartForm = root.querySelector('.aleta-form');
    function aletaFlashAdded(){
      try{
        if(addBtn){ addBtn.classList.add('is-added'); }
        if(addLbl){ addLbl.textContent = 'Added to bag ✓'; }
        if(stickyBtn){ stickyBtn.classList.add('is-added'); stickyBtn.textContent = 'Added ✓'; }
        setTimeout(function(){
          if(addBtn){ addBtn.classList.remove('is-added'); }
          if(addLbl){ addLbl.textContent = 'Add to bag'; }
          if(stickyBtn){ stickyBtn.classList.remove('is-added'); stickyBtn.textContent = 'Add to bag'; }
        }, 2200);
      }catch(e){}
    }
    function aletaBumpCart(count){
      var els = document.querySelectorAll('.cart-count,[data-cart-count],.cart-count-bubble,#cart-icon-bubble,[data-cart-count-bubble],.header__cart-count,.cart-link__bubble,.js-cart-count,.cart-item-count,.cart-count-badge');
      els.forEach(function(el){
        if(typeof count === 'number' && /^\s*\d*\s*$/.test(el.textContent)){ el.textContent = count; }
        el.classList.remove('aleta-cart-bump'); void el.offsetWidth; el.classList.add('aleta-cart-bump');
      });
    }
    if(cartForm && !cartForm.dataset.aletaCart){
      cartForm.dataset.aletaCart = '1';
      cartForm.addEventListener('submit', function(e){
        e.preventDefault();
        if(cartForm.dataset.busy === '1') return;
        cartForm.dataset.busy = '1';
        if(addBtn){ addBtn.classList.add('is-loading'); }
        if(stickyBtn){ stickyBtn.classList.add('is-loading'); }

        var fd = new FormData(cartForm);
        /* ask Shopify to re-render the theme's cart-drawer section(s) so the drawer can
           refresh with the new item and slide open (Horizon's <cart-drawer-component> auto-opens on cart:update) */
        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function(el){
          if(el.dataset && el.dataset.sectionId && sectionIds.indexOf(el.dataset.sectionId) === -1){ sectionIds.push(el.dataset.sectionId); }
        });
        if(sectionIds.length){ fd.append('sections', sectionIds.join(',')); }

        var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) ? Theme.routes.cart_add_url : '/cart/add.js';
        fetch(addUrl, { method:'POST', headers:{ 'Accept':'application/json', 'X-Requested-With':'XMLHttpRequest' }, body: fd })
          .then(function(r){ return r.json().then(function(d){ return { ok:r.ok, d:d }; }); })
          .then(function(res){
            cartForm.dataset.busy = '0';
            if(addBtn){ addBtn.classList.remove('is-loading'); }
            if(stickyBtn){ stickyBtn.classList.remove('is-loading'); }
            if(!res.ok){
              if(addLbl){ addLbl.textContent = (res.d && res.d.description) ? res.d.description : 'Unavailable'; setTimeout(function(){ addLbl.textContent = 'Add to bag'; }, 2600); }
              return;
            }
            aletaFlashAdded();
            var addResp = res.d;
            fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
              .then(function(r){ return r.json(); })
              .then(function(cart){
                aletaBumpCart(cart.item_count);
                /* fire the theme's own cart:update event: cart-items-component morphs its
                   section from detail.data.sections, and the cart drawer (auto-open) slides out */
                try{
                  var ev = new Event('cart:update', { bubbles:true });
                  ev.detail = {
                    resource: cart,
                    sourceId: 'aleta-pdp',
                    data: {
                      source: 'aleta-product',
                      itemCount: cart.item_count,
                      variantId: String((addResp && (addResp.variant_id || addResp.id)) || ''),
                      sections: (addResp && addResp.sections) || {}
                    }
                  };
                  document.dispatchEvent(ev);
                }catch(err){}
              })
              .catch(function(){ aletaBumpCart(); });
          })
          .catch(function(){ cartForm.dataset.busy = '0'; cartForm.submit(); });
      });
    }

    /* ---------- sticky add bar via IntersectionObserver on the CTA ---------- */
    var sticky = root.querySelector('[data-sticky]');
    var anchor = root.querySelector('.aleta-add');
    if(root._aletaIO){ root._aletaIO.disconnect(); }
    if(sticky && anchor && 'IntersectionObserver' in window){
      root._aletaIO = new IntersectionObserver(function(entries){
        var e = entries[0];
        var below = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', below);
        sticky.hidden = !below;
      }, { threshold: 0 });
      root._aletaIO.observe(anchor);
    }

    refreshPrice();
  }

  function initAll(scope){ (scope || document).querySelectorAll('.aleta-pdp').forEach(initAletaPdp); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ initAll(); }); }
  else { initAll(); }
  /* re-init after theme-editor re-renders so nothing "breaks" while customizing */
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:section:unload', function(e){
    var root = e.target.querySelector('.aleta-pdp');
    if(root && root._aletaIO){ root._aletaIO.disconnect(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
